module.exports = __webpack_public_path__ + "static/media/KIABI.50e5a9d0.svg";